import * as logs from "./logs";

export const roulette = {
    ...logs
}